import { useState } from "react";
import { Flag, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

const REASONS = ["Beleidigung oder Hetze", "Spam oder Werbung", "Nacktheit oder Gewalt", "Falschinformation oder Betrug", "Urheberrecht oder fremde Fotos", "Sonstiges"];

function ReportDialog({ kind, targetId, onClose }) {
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      await api.post("/reports", { kind, target_id: targetId, reason: note.trim() ? `${reason}: ${note.trim()}` : reason });
      toast.success("Danke! Unser Team schaut sich das an.");
      onClose();
    } catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-3xl" data-testid="report-dialog">
        <DialogTitle className="font-bold flex items-center gap-2"><Flag className="w-4 h-4 text-rose-500" /> {kind === "post" ? "Beitrag" : "Kommentar"} melden</DialogTitle>
        <DialogDescription className="text-sm text-slate-500">Deine Meldung ist anonym – nur unser Team sieht, wer gemeldet hat.</DialogDescription>
        <div className="space-y-1.5">
          {REASONS.map((r, i) => (
            <button key={r} type="button" onClick={() => setReason(r)} data-testid={`report-reason-${i}`}
              className={`w-full text-left px-4 h-11 rounded-2xl border text-sm font-semibold transition-colors ${reason === r ? "border-rose-400 bg-rose-50 text-rose-700" : "border-pink-100 hover:bg-rose-50/50"}`}>{r}</button>
          ))}
        </div>
        <textarea value={note} onChange={(e) => setNote(e.target.value)} maxLength={200} rows={2} placeholder="Optional: kurze Erklärung" data-testid="report-note"
          className="w-full rounded-2xl border border-pink-100 p-3 text-base sm:text-sm focus:outline-none focus:ring-2 focus:ring-rose-300 resize-none" />
        <button onClick={send} disabled={!reason || busy} data-testid="report-submit" className="h-11 rounded-full pink-gradient text-white font-bold text-sm flex items-center justify-center gap-2 disabled:opacity-50">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Melden
        </button>
      </DialogContent>
    </Dialog>
  );
}

export function ReportButton({ kind, targetId, ownerId, className = "", label = false }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  if (!user || user.user_id === ownerId) return null;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid={`report-${kind}-${targetId}`} title="Melden" aria-label="Melden" className={`inline-flex items-center gap-1 hover:text-rose-600 transition-colors ${className}`}>
        <Flag className="w-3.5 h-3.5" />{label && " Melden"}
      </button>
      {open && <ReportDialog kind={kind} targetId={targetId} onClose={() => setOpen(false)} />}
    </>
  );
}
